/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLanguagesResult } from '../../models/get-languages-result';

export interface ApiLanguagesGet$Params {
}

export function apiLanguagesGet(http: HttpClient, rootUrl: string, params?: ApiLanguagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLanguagesResult>> {
  const rb = new RequestBuilder(rootUrl, apiLanguagesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLanguagesResult>;
    })
  );
}

apiLanguagesGet.PATH = '/api/Languages';
